import { CommonParam } from "./CommonParam";
import { v_InvoiceLineItemBus } from "./v_InvoiceLineItemBus";
import { QILineItemBus } from "./QILineItem";

export class QIParam extends CommonParam
{
    lineItems: QILineItemBus[];
    lineItems2: v_InvoiceLineItemBus[];
}
